import { createI18n } from 'vue-i18n';
import Cookies from 'js-cookie';
import axios from 'axios';

import en from '../locales/en.json';
import fr from '../locales/fr.json';
import ar from '../locales/ar.json';

const messages = { en, fr, ar };

export async function setupI18n() {
	let locale = Cookies.get('lang');

	if (!locale) {
		try {
			const res = await axios.get('/acl/locals');
			locale = res?.data?.hostConfig?.default_locale || 'en';
			console.log('from api', locale);
			Cookies.set('lang', locale, { expires: 365 });
		} catch (e) {
			console.error('Failed to get locale from API:', e);
			locale = 'en';
		}
	}

	const i18n = createI18n({
		legacy: true,
		locale,
		fallbackLocale: 'en',
		messages,
	});

	return i18n;
}
